import React, {FC} from 'react'
import {KTIcon} from '../../../_metronic/helpers'
import {Field, getIn, ErrorMessage} from 'formik'
type CheckBoxCompleteType = {
  errors: any
  touched: {}
  label: string
  name: string
  required?: boolean
  type?: string
}
const CheckBoxComplete: FC<CheckBoxCompleteType> = ({
  errors,
  touched,
  label,
  name,
  required = true,
}) => {
  const submit_form = getIn(touched, name)
  const submit_form_error = getIn(errors, name)
  return (
    <>
      {label !== '' ? (
        <label className={'form-label ' + (required ? 'required' : '')}>{label}</label>
      ) : null}
      <div className='position-relative'>
        <Field type='checkbox' className='form-check-input' name={name} />
        <div className='position-absolute translate-middle-y top-50 end-0 me-3 '>
          {submit_form && !submit_form_error ? (
            <KTIcon iconName='check' iconType='solid' className='fs-2hx text-success' />
          ) : submit_form ? (
            <KTIcon iconName='cross' iconType='solid' className='fs-2hx text-danger' />
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className='text-danger mt-2'>
        <ErrorMessage data-testid={name} name={name} />
      </div>
    </>
  )
}

export default CheckBoxComplete
